import { getBaseUrl } from '../../Utils'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'

export interface IAggricateObj {
  AggregateFunction: string,
  AggregationType: string | null,
  DataType: number,
  Default: boolean,
  SqlAggregateFunction: string,
  name: string
}

export interface IVUParamsSubCategory {
  FieldKey: number
  CategoryName: string
  FieldName: string
  FieldDesc: string
  DataType: number
  FunctionName_forhavingclause: string
  FunctionNameText: string
  ScaleId: number
  RankOrganizer: number
  DrillThruType: string
  DrillThruDefault: any
  SqlColumnFunction: string
  SqlColumnFunctionText: string
  SqlFieldName: string
  SqlColumnName1_distinct: string
  SqlColumnName1: string
  SqlTableName1: string
  SqlTableName1_PK: string
  SqlAliasName1: string
  SqlFactTableName: string
  SqlFactTableName_PK: string
  SqlFactTableJoinKey: string
  SqlFactTableAliasName: string
  SqlFactGroupName: string
  SqlFilter: string
  FactFilter: any
  Get_FilterfromFact: any
  DisplayOrder: number
  EmptyColor: any
  JavascriptTarget: any
  JavascriptTargetParams: any
  hideInDrillThru: any
  MDSColumnId: number
  DisplayInPalette: boolean
  EncryptforMDSCId: any
  fk_ocvid: number
  TableType: any
  IsFactColNonNullable: boolean
  additionalClasses: string
  Available: boolean
  Filterable: boolean
  Measurable: boolean
  CategoryDisplayOrder: any
  FieldDisplayOrder: any
  ShowInUserSettings: boolean
  ShowUserSettingsFilter: boolean
  AddNewVUDefault: boolean
  FunctionName: any
  Cardinality: number
  DisplayRows: number
  IsPii: boolean
  MetaDataFieldId: number
  DimensionTableJoinKey: any
  Fk_CategoryId: any
  _internalkey: number
  FactGroupName: any
  ComputedCategoryName: any
  DefaultFilters: any
  Fk_DrillThruTypeId: any
  fk_FactTable: number
  FactTableName: any
}
export interface IBusinessParameter {
  Id: number
  Guid: string
  Name: string
  Description: string
  CreatedBy: string
  CreatedOn: string
  LastUpdatedOn: string
  Scope: number
  ScopeName: string
  SourceId: number
  SourceName: string
  DataType: number
  _DataType: string
  BPValue: string
  ValidUntilString: string
  Available: string
  ValidUntil: string
  ValidUntilFormatted: string
  UsedIn: number
  IsSecured: boolean
  ForDepartmentId: any
  ForUserId: any
  Links: Links
  Warning: string
  MessageResults: any[]
}

export interface IMeasureSetList {
  Id: number
  Guid: string
  Name: string
  Description: string
  DataType: string | number
}

export interface Links { }

export interface ISingleValueReportList {
  id: number
  name: string
  description: string
  userId: number
  createdBy: string
  createdOn: string
  lastUpdatedOn: string
  isSummary: boolean
  privacyLock: number
  updatedByUserId: number
  viewerType: number
}

export interface IMetadataFilterSearchList {
  Available: boolean, 
  DataType: number, 
  DisplayOrder: number, 
  DisplayText: string, 
  FilterCondition: any, 
  KeyValue: string, 
  MetaDataId: number, 
  SqlFilterCondition: any, 
  _internal_types_filterlookup: number
}

export interface IBinResponseObj {
  BinType: number
  CanDrillThru: string
  DataType: number
  Default: boolean
  Description: string
  FieldNameSuffix: string
  Id: number
  Links: Links
  MessageResults: any[]
  Name: string
  SortOrder: number
  SqlColumnName: string
  SqlColumnText: string
  SqlDataType: number
  SqlGroupNumber: string
  Warning: string
}

export const getAggricateListAPI = createApi({
  reducerPath: "getAggrList",
  tagTypes: ["VUParamsAggricateList"],
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl() + 'API/v3',
  }), //The base API path
  // The "endpoints" represent operations and requests for this server
  endpoints: (build) => ({
    // The `getPosts` endpoint is a "query" operation that returns data
    getAggricateList: build.mutation({
      query: (body) => ({
        url: `/visualunit/GetAggregateList`,
        method: 'POST',
        body: body,
      }),
    }),
    getBusinessParameterList: build.mutation({
      query: (body) => ({
        url: `/BusinessParameters/GetBusinessParameters?_=1734429353011`,
        method: 'GET',
        // body: body,
      }),
    }),
    getSingleValueReports: build.mutation({
      query: (body) => ({
        url: `/visualunit/GetSingleValueReportsForVU`,
        method: 'POST',
        body: APIHelper.prepareFormData(body),
      }),
    }),
    getBusinessParameters: build.mutation({
      query: (body) => ({
        url: `/BusinessParameters?dataType=${body.datatype}&_=1734534327906`,
        method: 'GET',
        // body: APIHelper.prepareFormData(body),
      })
    }),
    getAllBusinessParamsList: build.query<any, void>({
      query: () => "/BusinessParameters/GetBusinessParameters",
    }),    
    getFilterSearchListMetaDataValue: build.mutation({
      query: (body) => ({
        url: `/MetaDataField/GetFilterSearchListMetaDataValue`,
        method: 'POST',
        body: body,
      }),
    }),
    getBinList: build.mutation({
      query: (body) => ({
        url: `/MetaDatas/BinList`,
        method: 'POST',
        body: body,
      }),
    }),
    getStratifies: build.mutation({
      query: (body) => ({
        url: `/Metadatas/stratifies`,
        method: 'POST',
        body: APIHelper.prepareFormData(body),
      }),
    }),
    getMeasureSetList: build.mutation({
      query: (body) => ({
        url: `/visualunit/GetMeasureSetsForVUEdit`,
        method: 'GET',
        // body: body,
      }),
    }),
  }),
})

export const { useGetAggricateListMutation, useGetBusinessParameterListMutation, useGetSingleValueReportsMutation, useGetBusinessParametersMutation, useGetFilterSearchListMetaDataValueMutation, useGetBinListMutation, useGetStratifiesMutation, useGetAllBusinessParamsListQuery, useGetMeasureSetListMutation } = getAggricateListAPI